import { GridColDef } from "@mui/x-data-grid";

const callerDidConfigDef: GridColDef[] = [
	{ field: 'id', headerName: 'ID', width: 200 },
	{ field: 'caller_did', headerName: 'Caller DID', width: 200},
	{ field: 'agency_name', headerName: 'Agency Name', width: 200},
	{ field: 'client_name', headerName: 'Client Name', width: 200},
	{ field: 'created_date', headerName: 'Created Date', width: 200},
	{ field: 'created_by', headerName: 'Created By', width: 200},
	{ field: 'updated_date', headerName: 'Updated Date', width: 200},
	{ field: 'updated_by', headerName: 'Updated By', width: 200}
];

export default callerDidConfigDef;